var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b53ac012-cd3c-484e-a20d-d6c80367fe17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ab41dfbf-8446-44fb-a199-bb94ade2a0a1, .ae499ccd-c91d-460e-b797-1d9b201f35dd, .b1c2744a-52d5-44f2-b9f0-7ec893ad7ae6, .b77a525b-11e0-4ca3-ba73-b85f68344085, .e89db45f-4d99-4d97-9ac1-6c8e3c30a344, .ec12a033-0713-4abc-915f-0aef8bfc5fa5 {\n        opacity: 0.5;\n      }\n\n      .e89db45f-4d99-4d97-9ac1-6c8e3c30a344 {\n        fill: url(#a7c85305-f289-4e96-8764-0a45fb62be38);\n      }\n\n      .ec12a033-0713-4abc-915f-0aef8bfc5fa5 {\n        fill: url(#f82bafdf-6e97-4799-917f-9fb78d0d9ba0);\n      }\n\n      .ab41dfbf-8446-44fb-a199-bb94ade2a0a1 {\n        fill: url(#f88fc01b-cf45-4a9e-851c-ad33f4e33d5b);\n      }\n\n      .aac58556-7668-475d-ab08-65e82aebe1fc {\n        fill: #fff;\n      }\n\n      .b1c2744a-52d5-44f2-b9f0-7ec893ad7ae6 {\n        fill: url(#b5368d8f-805a-4163-a276-5db32a2346d5);\n      }\n\n      .b77a525b-11e0-4ca3-ba73-b85f68344085 {\n        fill: url(#a74b5fff-b5fd-429d-a04f-b6318b24dc90);\n      }\n\n      .ae499ccd-c91d-460e-b797-1d9b201f35dd {\n        fill: url(#a1ef0e22-4311-488c-85bf-8880aedea598);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7c85305-f289-4e96-8764-0a45fb62be38",
    x1: 6058.01,
    y1: 4393.04,
    x2: 6059.44,
    y2: 4377.13,
    gradientTransform: "translate(2983.9 -6845.01) rotate(77.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f82bafdf-6e97-4799-917f-9fb78d0d9ba0",
    x1: 6058.01,
    y1: 4393.04,
    x2: 6059.44,
    y2: 4377.13,
    gradientTransform: "translate(2983.9 -6845.01) rotate(77.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f88fc01b-cf45-4a9e-851c-ad33f4e33d5b",
    x1: 613.35,
    y1: -4425.23,
    x2: 614.78,
    y2: -4441.15,
    gradientTransform: "translate(2616.91 3676.93) rotate(-43.25)",
    xlinkHref: "#a7c85305-f289-4e96-8764-0a45fb62be38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b5368d8f-805a-4163-a276-5db32a2346d5",
    x1: 6058.01,
    y1: 4393.04,
    x2: 6059.44,
    y2: 4377.13,
    xlinkHref: "#a7c85305-f289-4e96-8764-0a45fb62be38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a74b5fff-b5fd-429d-a04f-b6318b24dc90",
    x1: 6058.01,
    y1: 4393.04,
    x2: 6059.44,
    y2: 4377.13,
    xlinkHref: "#f82bafdf-6e97-4799-917f-9fb78d0d9ba0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1ef0e22-4311-488c-85bf-8880aedea598",
    x1: 613.35,
    y1: -4425.23,
    x2: 614.78,
    y2: -4441.15,
    gradientTransform: "translate(2616.91 3676.93) rotate(-43.25)",
    xlinkHref: "#a7c85305-f289-4e96-8764-0a45fb62be38"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e89db45f-4d99-4d97-9ac1-6c8e3c30a344",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e89db45f-4d99-4d97-9ac1-6c8e3c30a344",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec12a033-0713-4abc-915f-0aef8bfc5fa5",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e89db45f-4d99-4d97-9ac1-6c8e3c30a344",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e89db45f-4d99-4d97-9ac1-6c8e3c30a344",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab41dfbf-8446-44fb-a199-bb94ade2a0a1",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab41dfbf-8446-44fb-a199-bb94ade2a0a1",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab41dfbf-8446-44fb-a199-bb94ade2a0a1",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab41dfbf-8446-44fb-a199-bb94ade2a0a1",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab41dfbf-8446-44fb-a199-bb94ade2a0a1",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aac58556-7668-475d-ab08-65e82aebe1fc",
    d: "M27.21,1,23.65,7.17H26.1a6.13,6.13,0,0,1-6,5.08,4.58,4.58,0,0,0-4.47,3.4,4.6,4.6,0,0,0,4.44,5.78,4.59,4.59,0,0,0,4-6.89,4.37,4.37,0,0,0-.72-.93,8.19,8.19,0,0,0,4.84-6.44h2.61ZM20.73,14.37a2.54,2.54,0,0,1,1.55,1.19,2.58,2.58,0,0,1,.26,1.94,2.55,2.55,0,0,1-3.13,1.8,2.55,2.55,0,0,1-.61-4.67,2.46,2.46,0,0,1,1.26-.34h0A2.8,2.8,0,0,1,20.73,14.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b1c2744a-52d5-44f2-b9f0-7ec893ad7ae6",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b77a525b-11e0-4ca3-ba73-b85f68344085",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1c2744a-52d5-44f2-b9f0-7ec893ad7ae6",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1c2744a-52d5-44f2-b9f0-7ec893ad7ae6",
    d: "M10.28,21.76,15.54,17,8.75,14.81l.53,2.39A6.14,6.14,0,0,1,3,12.4a1,1,0,0,0-2,.44,8.19,8.19,0,0,0,8.7,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae499ccd-c91d-460e-b797-1d9b201f35dd",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae499ccd-c91d-460e-b797-1d9b201f35dd",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae499ccd-c91d-460e-b797-1d9b201f35dd",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae499ccd-c91d-460e-b797-1d9b201f35dd",
    d: "M30.07,22.2l-6.82-2.05,1.63,6.93,1.79-1.68a6.14,6.14,0,0,1-.92,7.84,1,1,0,1,0,1.4,1.48,8.18,8.18,0,0,0,1-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aac58556-7668-475d-ab08-65e82aebe1fc",
    d: "M27.21,1,23.65,7.17H26.1a6.13,6.13,0,0,1-6,5.08,4.58,4.58,0,0,0-4.47,3.4,4.6,4.6,0,0,0,4.44,5.78,4.59,4.59,0,0,0,4-6.89,4.37,4.37,0,0,0-.72-.93,8.19,8.19,0,0,0,4.84-6.44h2.61ZM20.73,14.37a2.54,2.54,0,0,1,1.55,1.19,2.58,2.58,0,0,1,.26,1.94,2.55,2.55,0,0,1-3.13,1.8,2.55,2.55,0,0,1-.61-4.67,2.46,2.46,0,0,1,1.26-.34h0A2.8,2.8,0,0,1,20.73,14.37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImg);
export default __webpack_public_path__ + "static/media/LogoImg.38dde560.svg";
export { ForwardRef as ReactComponent };